export enum GameStatus {
    Betting = 2,
    MultiplierIncrease,
    Bust,
}
